import products from "./ski-pass-products.json";

export type SkiPassChoice = { areaSlug: string; resortSlug: string; scope: "local" | "linked" };
export type SkiPassProduct = {
  linkedLabel: string; sourceUrls: readonly string[]; note?: string;
  resorts: Readonly<Record<string, { localLabel?: string; sharedPassOnly?: boolean; note?: string }>>;
};
const catalogue: Readonly<Record<string, SkiPassProduct>> = products;

export function skiPassProduct(areaSlug: string): SkiPassProduct | undefined {
  return Object.hasOwn(catalogue, areaSlug) ? catalogue[areaSlug] : undefined;
}

export function resortPassProduct(areaSlug: string, resortSlug: string) {
  const area = skiPassProduct(areaSlug);
  return area && Object.hasOwn(area.resorts, resortSlug) ? area.resorts[resortSlug] : undefined;
}

export function localPassName(areaSlug: string, resortSlug: string): string | undefined {
  return resortPassProduct(areaSlug, resortSlug)?.localLabel;
}

export function coerceSkiPass(raw: unknown): SkiPassChoice | undefined {
  if (raw == null) return undefined;
  const value = typeof raw === "object" && !Array.isArray(raw) ? raw as Record<string, unknown> : {};
  // An invalid supplied choice must fail validation, never silently widen access.
  return { areaSlug: typeof value.areaSlug === "string" && ["local", "linked"].includes(String(value.scope)) ? value.areaSlug.slice(0, 200) : "",
    resortSlug: typeof value.resortSlug === "string" ? value.resortSlug.slice(0, 200) : "", scope: value.scope === "linked" ? "linked" : "local" };
}

export function skiPassDescription(pass: SkiPassChoice, areaName: string): string {
  return pass.scope === "linked" ? `Pass coverage: ${skiPassProduct(pass.areaSlug)?.linkedLabel ?? areaName}.`
    : `Pass coverage: ${localPassName(pass.areaSlug, pass.resortSlug) ?? areaName} only.`;
}
